import { UserModel } from 'data/user/user.model';
import moment from 'moment';
import React from 'react';

export const AllUsersTableColumn = () => [
  {
    name: 'Username',
    selector: 'username',
    sortable: true,
    cell: (row: UserModel) => <div>{row.username}</div>,
  },
  {
    name: 'Full Name',
    selector: 'fullName',
    sortable: true,
    cell: (row: UserModel) => <div>{row.full_name}</div>,
  },
  {
    name: 'Email',
    selector: 'email',
    sortable: true,
    cell: (row: UserModel) => <div>{row.email}</div>,
  },
  {
    name: 'Role',
    selector: 'role',
    sortable: true,
    width: 500,
    cell: (row: UserModel) => (
      <div>
        {row.__roles__.map((role) => (
          <div
            style={{
              width: 180,
              background: `${
                role.role_description === 'Student'
                  ? 'var(--blue)'
                  : role.role_description === 'Teacher'
                  ? 'var(--red)'
                  : role.role_description === 'Parent'
                  ? 'var(--purple)'
                  : role.role_description === 'Support Person'
                  ? 'var(--yellow)'
                  : 'var(--green'
              }`,
              borderRadius: 40,
              padding: '5px 5px 5px 5px',
              color: 'var(--white)',
              textAlign: 'center',
              fontSize: 'var(--font-sm)',
            }}
            // className={`page-tabs-item ${item === selectedUser ? 'active' : ''}`}
          >
            {role.role_description}
          </div>
        ))}
      </div>
    ),
  },
  {
    name: 'Created At',
    selector: 'createdAt',
    sortable: true,
    cell: (row: UserModel) => <div>{moment(row.created_at).format('Do MMM, YYYY')}</div>,
  },
];
